<template>
  <div class="top-header-container">
    <BackButton :clickMethod="back" class="mb-3"/>

    <h4>
      {{ $tI('Hunter Gatherer and Farmer Breakdown') }}
      <span @click="hgFarmerInfoModal.showModal = true" class="open-info-modal-btn"
        v-click-track="'Iframe.ancientDnaHunterGathererAndFarmerReportTooltipClicked'">
        <InfoIcon />
      </span>
    </h4>
    <p class="description">
      {{ $tI_YO_G('Hunter-Gatherer and Farmer Subtitle') }}
    </p>

    <hgFarmerInfoModal v-if="hgFarmerInfoModal.showModal" :modalObject="hgFarmerInfoModal"/>
  </div>
</template>

<script>
import BackButton from '@/components/ui/BackButton.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import HgFarmerInfoModal from './modals/HgFarmerInfoModal.vue';

export default {
  components: {
    BackButton,
    InfoIcon,
    HgFarmerInfoModal,
  },
  data() {
    return {
      hgFarmerInfoModal: {
        showModal: false,
      },
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'dashboard' });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-header-container {
  padding: 28px;
  background-color: var(--white-100);
}
</style>